<template>
    <div>
        <el-dialog :visible.sync="dialogVisible" width="1000px" class="easyDig" :append-to-body="true"
            :close-on-click-modal="false" :before-close="handleClose">
            <!-- 自定义标题栏 -->
            <template #title>
                <div class="custom-header">
                    <img style="margin-right: 10px;" src="../../assets/img/easyDigTit.svg" alt="">
                    <span> {{ lang.createEasyApp }}</span>
                </div>
            </template>
            <div class="easyDigMim" v-loading="loading" :element-loading-text="lang.createEasyAppLoading">
                <!-- <div class="select_box">
                    <el-select
                        v-model="subject"
                        :placeholder="lang.subject"
                        style="width: 200px"
                        @change='getData()'
                    >
                    
                        <el-option
                                v-for="item in lang.subjectList2"
                                :key="item.id"
                                :label="item.label"
                                :value="item.id"
                            >
                        </el-option>
                    </el-select>
                </div> -->
                <div class="search_box">
                    <span>{{ lang.search }}</span>
                    <el-input v-model="evalue" :placeholder="lang.title" size="normal" clearable @input="searchTitle" style="width: 200px;"></el-input>
                </div>
                <div class="select_box">
                    <span v-for="item in subList" :key="item.id" @click="search(item)" :class="{active: subject == item.id}">{{ item.label }}</span>
                </div>
                <!-- <div class="title">{{ lang.tem }}</div> -->
                <!-- <div class="check_box">
                    <span :class="{ active: type == 0 }" @click="checkType(0)">{{ lang.simpleMode2 }}</span>
                    <span :class="{ active: type == 1 }" @click="checkType(1)">{{ lang.advancedMode2 }}</span>
                </div> -->
                <div class="easy_box" style="flex-direction: column;">
                    <div v-for="(sub, sIndex) in appList" :key="sIndex"  class="easy_box2">
                        <div class="title">{{ sub.label }}</div>
                        <!-- :class="{ active: json.id == i.id }" -->
                        <div v-for="(i, index) in sub.apps" :key="sIndex + '' + index" class="easyDigCon" @click="pickTem(i)">
                            <!-- <div class="checkbox">
                                <div class="c_dang"></div>
                                <el-checkbox v-model="i.checked"></el-checkbox>
                            </div> -->
                            <div class="con">
                                <div class="title">
                                    <img class="img" style="border-radius: 6px;" :src="i.content.headUrl" alt="">
                                    <el-tooltip
                                        class="item"
                                        effect="light"
                                        :content="i.type == 0 ? i.content.assistantName : i.content.muti_name"
                                        placement="top"
                                    >
                                        <div class="name">{{ i.type == 0 ? i.content.assistantName : i.content.muti_name }}</div>
                                    </el-tooltip>
                                    <!-- v-if="user.userId == i.userid" -->
                                    <div class="btn" v-if="user.userId == i.userid">
                                        <el-button v-if="i.type == 0" type="primary" size="mini" icon="el-icon-edit" class="confirm btnb"
                                            @click="editApp(i)">{{
                                                lang.edit
                                            }}</el-button>
                                        <el-button type="danger" size="mini" icon="el-icon-delete" class="delete btnb"
                                            @click="deleteApp(i.id)">{{
                                                lang.delete
                                            }}</el-button>
                                    </div>
                                </div>
                                <div>
                                    {{ i.content.description }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="title">{{ lang.tem }}</div> -->

                    <div class="empty_box" v-if="!appList.length">
                        <img src="@/assets/img/appCenter/appManagement/empty_appImg.svg" alt="" />
                    </div>
                </div>

            </div>

            <!-- <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="handleClose">{{ lang.cancel }}</el-button>
                <el-button size="small" type="primary" style="background-color: #0354D7;" @click="pickTem">{{
                    lang.queding
                    }}</el-button>
            </span> -->
        </el-dialog>
    </div>
</template>

<script>
import { mapMutations } from 'vuex';
import {myMixin} from "@/common/mixin.js";

export default {
    mixins:[myMixin],
    // 社区进行模板创建接收社区id
    props: {
        cyid: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            dialogVisible: false,
            loading: false,
            appList: [],
            appList2: [],
            queryTem: [],
            type: 0,
            subject: "",
            json: {},
            subList: [],
            evalue: "",
        }
    },
    methods: {
        ...mapMutations(['set_template_json']),
        // 模板只能单选
        checkSelect(val) {
            console.log(val);
            if(val.id == this.json.id){
                this.json = {}
            }else{
                this.json = val
            }
            // this.appList.forEach(e => {
            //     if (e.id != val.id) {
            //         e.checked = false
            //     }
            //     if(e.id == val.id && type == 1){
            //         e.checked = !e.checked
            //     }
            // })
        },
        pickTem(json) {

            // this.$router.push({
            //     path: "/AgentPage",
            //     query: {
            //         id: '385c7601-d3f1-4a35-bfef-7445d62d4d6d',
            //         create: false,
            //         isTem : 1
            //     },
            // });
            //     this.dialogVisible = false
            if(this.loading){
                return
            }


            let conP = json.content ? json.content : {}
            let conP2 = json
            if (!Object.keys(conP).length || conP.length == 0) return this.$message.info(this.lang.temChooseTip)
            this.loading = true

            let con = JSON.parse(JSON.stringify(conP))
            console.log('con', con);


            // con.userId = this.user.userId;
            // con.username = this.user.userName;
            // con.assistantName = con.assistantName +'-'+ this.user.userName;
            // con.organize_id = this.user.organizeid;

            // con.assistant_id = ''
            // con.thread_id = ''

            // delete con.updatetime; 
            // delete con.createtime; 
            // delete con.id; 
            // delete con.appid; 
            // delete con.assistant_id; 
            // delete con.parentDataId; 



            this.addOp3(1, "", { id: conP2.id, type: 'create_from_template'}, "success", 1)

            if(conP2.type == 1){
                this.dialogVisible = false
                this.loading = false
                this.set_template_json(conP2)
                this.$router.push({
                    path: "/workFlow",
                    query: {
                        templateid: conP2.id,
                        create: true,
                        cyid: this.cyid, //模板创建工作流时
                        isTem: 1
                    },
                });
            }else {
                const config = {
                    method: 'post',
                    url: this.new_url + '/api/agents/agent',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    data: {
                        userId: this.user.userId,
                        username: this.user.userName,
                        agent_sort: con.agent_sort,
                        agent_tag: con.agent_tag,
                        assistantName: con.assistantName + '-' + this.user.userName,
                        description: con.description,
                        prologue: con.prologue,
                        headUrl: con.headUrl,
                        instructions: con.instructions || "",
                        isRetrieval: 0,
                        isCode: 0,
                        isGoogle: 0,
                        isDalleImage: 0,
                        functionNames: con.functionNames,
                        functionContents: con.functionContents,
                        assistant_id: '',
                        thread_id: '',
                        file_ids: con.file_ids ? con.file_ids : "",
                        file_names: con.file_names ? con.file_names : "",
                        folder_ids: con.folder_ids ? con.folder_ids : "",
                        folder_names: con.folder_names ? con.folder_names : "",
                        isPublish: 0,
                        organize_id: this.user.organizeid,
                        vector_store_id: '',
                        modelType: con.modelType,
                        isAutoReply: con.isAutoReply ? 1 : 0,
                        inputMode: con.inputMode,
                        outputMode: con.outputMode,
                    },
                };
                console.log('config', config);

                this.$axios(config).then((res) => {
                    console.log(res.data)
                    this.dialogVisible = false
                    this.loading = false

                    this.$router.push({
                        path: "/AgentPage",
                        query: {
                            id: res.data.id,
                            create: false,
                            cyid: this.cyid, //模板创建智能体
                            isTem: 1
                        },
                    });

                }).catch((error) => {
                    this.loading = false

                    // this.$message.error(this.lang.serverBusy);
                    console.log(error);
                });

            }
        },
        deleteApp(id) {
            this.$confirm(this.lang.comfim_delete, this.lang.tip, {
                confirmButtonText: this.lang.queding,
                cancelButtonText: this.lang.cancel,
                type: "warning",
            })
                .then(() => {
                    let params = {
                        id: id
                    }

                    this.ajax
                        .post(this.$store.state.api + "deleteAppTem", [params])
                        .then(res => {
                            console.log('res', res);
                            this.$message.success(this.lang.delete_cg)
                            this.getData();
                        })
                        .catch(err => {
                            console.error(err);
                        });
                })
                .catch((error) => {
                    console.log(error);
                    // this.$message({
                    //     type: "info",
                    //     message: this.lang.canceled,
                    // });
                });


        },
        editApp(i) {
            this.dialogVisible = false

            this.$router.push({
                path: "/AgentPage",
                query: {
                    id: i.content.id,
                    create: false,
                    isTem: 2
                },
            });
        },
        open() {
            this.dialogVisible = true
            this.getData();
        },
        search(item){
            if(this.subject == item.id){
                return
            }
            this.subject = item.id; 
            this.getData();
        },
        getData() {
            this.loading = true
            let params = {
                oid: this.user.organizeid + ',' + this.user.org,
                type: "",//this.type
                subject: "",//this.type
                area: this.user.orgArea,
                // this.subject
            }

            this.ajax
                .get(this.$store.state.api + "selectAppTem3", params)
                .then(res => {
                    console.log('res', res);
                    let data = res.data[0]
                    this.json = {}
                    let subList = JSON.parse(JSON.stringify(this.lang.subjectList2.filter(item => item.id != '')))
                    subList.forEach(item => {
                        item.apps = data.filter(e => {
                            return (e.subject && e.subject.includes(item.id)) || (!e.subject && item.id == 'other')
                        }
                        ).map((e) => {
                            if (typeof e.content === 'string') {
                                e.content = JSON.parse(e.content);
                            }
                            return e;
                        })
                    });

                    subList = subList.filter(e => {
                        return e.apps.length > 0
                    });
                    console.log(subList);
                    this.subList = [this.lang.subjectList2[0]].concat(subList)
                    this.appList = this.subject ? subList.filter(e => e.id == this.subject) : subList;
                    this.appList2 = this.subject ? subList.filter(e => e.id == this.subject) : subList;
                    this.searchTitle()
                    // this.appList.filter(e => {
                    //     if(!this.json.id){
                    //         this.json = e.apps[0]
                    //     }
                    // });
                    // this.loading = false
                })
                .catch(err => {
                    this.loading = false
                    console.error(err);
                });
        },
        searchTitle(){
            // this.loading = true
            clearTimeout(this.searchTitleTimer);
            this.searchTitleTimer = setTimeout(() => {
                // todo: search title logic
                this.appList = this.appList2.map(e => ({
                    ...e,
                    apps: e.apps.filter(app => app.type === 0 ? app.content.assistantName.includes(this.evalue) : app.content.muti_name.includes(this.evalue))
                })).filter(e => e.apps.length > 0);
                this.loading = false
            }, 300);
        },
        checkType(type){
            this.type = type
            this.appList = []
            this.getData()
        },
        handleClose() {
            this.dialogVisible = false
        }
    },
}
</script>

<style scoped>
.easyDig>>>.el-dialog {
    border-radius: 12px;
}

.easyDig>>>.el-dialog__body {
    height: 420px;
}


.easyDig>>>.el-dialog__header {
    background-color: #FAFBFC;
    border-radius: 12px 12px 0 0;
}

.custom-header {
    display: flex;
    align-items: center;
    height: 26px;
}

.custom-header span {
    font-family: PingFang SC;
    font-weight: 600;
    font-size: 18px;
    letter-spacing: 0px;
    color: #000000E5;
}

.easyDigMim {
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: 16px;
}

.easyDigMim>.title {
    font-family: PingFang SC;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #000000E5;
}

.easy_box{
    display: flex;
    flex-direction: row;
    /* flex-wrap: wrap; */
    gap: 10px;
    flex: 1;
    overflow: auto;
    padding: 0 10px 10px;
    box-sizing: border-box;
}

.easy_box2{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 15px;
    width: 100%;
}
.easy_box2>.title {
    font-family: PingFang SC;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #000000E5;
    width: 100%;
    margin-top: 10px;
}

.easyDigCon {
    /* border: 1px #9BC0FE solid; */
    /* border: 1px #e8e8e8 solid; */
    box-shadow: 2px 4px 10px 1px rgba(0, 0, 0, 0.2);
    transition: .3s all;
    border-radius: 6px;
    padding: 15px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    gap: 10px;
    height: 120px;
    width: calc(100% / 3 - 15px);
    position: relative;
    cursor: pointer;
    transition: all .3;
}

.easyDigCon.active,
.easyDigCon:hover{
    /* border: 1px #9BC0FE solid; */
    /* border: 1px #e8e8e8 solid; */
    box-shadow: 2px 4px 10px 0 rgba(5, 96, 253, 0.3);
}
.easyDigCon .checkbox{
    position: relative;
}
.easyDigCon .checkbox> .c_dang{
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 10;
}
.easyDigCon img {
    width: 40px;
    height: 40px;
    object-fit: cover;
}

.con {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    /* height: 75px; */
    flex: 1;
    gap: 8px;
    width: 100%;
}

.con>.title {
    display: flex;
    align-items: center;
}

.con>.title>.name {
    flex: 1;
    overflow: hidden;
    display: block;
    text-overflow: ellipsis;
    width: 100px;
}

.con>div:nth-child(1) {
    font-family: PingFang SC;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #000000E5;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    gap: 16px;
}

.con>div:nth-child(2) {
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    flex: 1;
    letter-spacing: 0%;
    color: #00000099;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}


.empty_box {
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: center;
    margin: auto;
}

.empty_box>img {
    width: 120px;
    height: auto;
}

.btn {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.btn>.btnb {
    height: 1.7rem;
    border-radius: .5rem;
    font-size: 12px;
    padding: 0 .7rem;
}

.btn>.confirm {
    margin: 0px;
    background: rgb(21, 90, 239);
    border: none;
}

.btn>.confirm:hover {
    background: rgb(0, 74, 235);
}

.btn>.delete {
    margin: 0 0 0px 10px;
    background: rgb(255, 255, 255);
    color: #354052;
    border: 1px solid #10182824;
}

.btn>.delete:hover {
    background: rgb(254, 243, 242);
    color: rgb(217, 45, 32);
}

.check_box{
    display: flex;
    gap: 15px;

}

.check_box > span{
    cursor: pointer;
}

.check_box > span.active{
    color: #0354d7;
    border-bottom: 2px solid;
}


.select_box{
    display: flex;
    gap: 10px 15px;
    flex-wrap: wrap;
    padding: 0 10px;
    box-sizing: border-box;
}

.select_box > span{
    cursor: pointer;
    color: #a6abb1;
    /* width: 70px; */
}

.select_box > span.active{
    color: #72a3f4;
}

.search_box{
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0 10px;
    box-sizing: border-box;
    width: 100%;
}
</style>